import { SB } from '@play-co/replicant';
import {
  duoAssets,
  duoInviteMessage,
  duoReminderMessage,
  duoResponseMessage,
} from './duo';
import { fullenergyMessage, fullenergyAssets } from './fullenergy';
import { speciesAssets } from './species';
import { stateAssets, statusMessage } from './status';
import { visitedAssets, visitedMessage } from './visited';

/**
 * Here we collect all templates variants and assets
 */

// Static assets used for generation flex messages templates
// Please prefix assets with flex_ prefix to avoid collisions
export const chatbotFlexAssets = {
  ...fullenergyAssets,
  ...speciesAssets,
  ...stateAssets,
  ...visitedAssets,
  ...duoAssets,
  // Add new assets here
};

/**
 * Add new messages templates here to make them available for usage
 *
 * For sending flexible message you should call:
 * @example
 *
 * // Create template
 * const message = getChatbotFlexMessage({
 *    data: { ... data required for message ... },
 *    template: 'fullenergy', <- See demoMessages const below
 *    payload: { ...standard message payload ...)
 * });
 *
 * // Send chatbot message
 * api.chatbot.sendMessage('USER ID', message);
 */
// Please prefix messages with flex_ prefix to avoid collisions
export const chatbotFlexTemplates = {
  fullenergy: fullenergyMessage,
  status: statusMessage,
  visited: visitedMessage,
  duoInvite: duoInviteMessage,
  duoReminder: duoReminderMessage,
  duoResponse: duoResponseMessage,
  // Add new templates here
};

// Available messages templates
export type FlexMessagesTemplate = keyof typeof chatbotFlexTemplates;

// Define list of required arguments
export type FlexMessagesArgs = {
  [key in FlexMessagesTemplate]: SB.ExtractType<
    typeof chatbotFlexTemplates[key]['args']
  >;
};
